import $ from 'jquery'
import { toolkitUrls } from '@/links'

export { getProfileDetail, getProfiles, updateAccountProfileId }

// options can include:
// refetch: 1
function getProfileDetail(profileId, options = {}) {
  if (!profileId) {
    throw 'Profile ID not specified'
  }
  return $.ajax({
    url: `${toolkitUrls.contentProfilesEndpoint}/profile/${profileId}?${$.param(options)}`,
    method: 'GET',
    dataType: 'json'
  })
}

// options can include:
// refetch: 1
function getProfiles(options = {}) {
  return $.ajax({
    url: `${toolkitUrls.contentProfilesEndpoint}/profiles?${$.param(options)}`,
    method: 'GET',
    dataType: 'json'
  })
}

function updateAccountProfileId({ userUuid, profileId }) {
  return $.ajax({
    url: `${toolkitUrls.contentProfilesEndpoint}/update_account`,
    method: 'PUT',
    contentType: 'json',
    data: JSON.stringify({ user_uuid: userUuid, content_profile_id: profileId }),
    xhrFields: { withCredentials: true }
  })
}
